import React, { useState, useEffect } from 'react';
import { Play, Pause, Smartphone, CheckCircle, AlertCircle, Trash2 } from 'lucide-react';
import { whatsappService } from '../services/api';

const CardInstancia = ({ instancia, onDelete }) => {
  const [isBotAtivo, setIsBotAtivo] = useState(instancia.bot_active ?? true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (instancia.bot_active !== undefined) {
      setIsBotAtivo(instancia.bot_active);
    }
  }, [instancia.bot_active]);

  const handleToggleBot = async () => {
    setLoading(true);
    const novoStatus = !isBotAtivo; 
    
    try {
      await whatsappService.alternarStatusBot(instancia.name, novoStatus);
      setIsBotAtivo(novoStatus);
    } catch (error) {
      console.error("Erro ao alterar status do bot:", error);
      alert(error.response?.data?.erro || "Houve um erro ao tentar mudar o status do bot. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const handleExcluir = async () => {
    const confirmar = window.confirm(`Excluir "${instancia.name}" desconecta esse número imediatamente e o robô para de responder por ele — essa ação não pode ser desfeita. Deseja continuar?`);
    if (!confirmar) return;

    setLoading(true);
    try {
      await whatsappService.excluirInstancia(instancia.name);
      if (onDelete) {
        onDelete(instancia.name); // Atualiza a lista na tela pai
      } else {
        alert("Instância excluída com sucesso!");
      }
    } catch (error) {
      console.error("Erro ao excluir instância:", error);
      alert(error.response?.data?.erro || "Houve um erro ao tentar excluir a instância. Tente novamente.");
      setLoading(false); // Só desativa o loading se der erro, pois se der sucesso o card vai sumir
    }
  };

  return (
    <div className="w-full bg-white dark:bg-slate-900 rounded-2xl p-5 border border-purple-50 box-border shadow-[0_4px_6px_-1px_rgba(109,40,217,0.05)] text-left">
      <div className="flex justify-between items-center mb-5 gap-2.5">
        <div className="flex gap-3 items-center flex-1 min-w-0">
          <div className="p-2.5 rounded-xl bg-[#F8F7FF] shrink-0 border border-purple-50/50">
            <Smartphone size={24} className={!isBotAtivo ? "text-slate-400" : "text-[#1883FF]"} />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="m-0 text-sm font-black uppercase text-slate-800 truncate" title={instancia.name}>
              {instancia.name}
            </h3>
            <p className="m-0 text-xs text-slate-500 font-semibold">{instancia.number || 'Conectado'}</p>
            {instancia.status_conexao && (
              <p className={`m-0 text-[9px] font-black uppercase tracking-wide mt-0.5 ${
                instancia.status_conexao === 'CONNECTED' ? 'text-green-600' :
                instancia.status_conexao === 'CONNECTING' ? 'text-amber-600' : 'text-red-500'
              }`}>
                {instancia.status_conexao === 'CONNECTED' ? '● Conexão ativa' : instancia.status_conexao === 'CONNECTING' ? '● Conectando...' : '○ Desconectado'}
              </p>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2 shrink-0">
          <div className={`flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] font-black ${isBotAtivo ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'}`} title="Se o robô está respondendo mensagens ou pausado manualmente">
            {isBotAtivo ? <CheckCircle size={12} /> : <AlertCircle size={12} />}
            {isBotAtivo ? 'ATIVO' : 'PAUSADO'}
          </div>

          {/* Botão de Excluir Instância */}
          <button 
            onClick={handleExcluir} 
            disabled={loading}
            title="Excluir Instância"
            className="flex items-center justify-center p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors bg-transparent border-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <Trash2 size={18} />
          </button>
        </div>
      </div>

      <div className="border-t border-purple-50 pt-4">
        <button 
          onClick={handleToggleBot} 
          disabled={loading}
          className={`w-full border-none h-11 rounded-xl font-black text-xs flex items-center justify-center gap-2 transition-all duration-200 ${isBotAtivo ? 'bg-[#F8F7FF] text-[#6D28D9] hover:bg-[#F5F3FF]' : 'bg-gradient-to-r from-[#1883FF] to-[#6D28D9] text-white shadow-md shadow-[#6D28D9]/20 hover:opacity-90 hover:-translate-y-0.5'} ${loading ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'}`}
        >
          {loading ? (
            'Processando...'
          ) : isBotAtivo ? (
            <><Pause size={16} /> PAUSAR ATENDIMENTO</>
          ) : (
            <><Play size={16} /> REATIVAR BOT</>
          )}
        </button>
      </div>
    </div>
  );
};

export default CardInstancia;